import React, { CSSProperties } from 'react'

import styled from '@emotion/styled'

import { typography } from '../../theme'
import { ArcadeColors, useGetArcadeColor } from '../../theme/arcadeColors'

const TextBase = styled.span<{
  themeColor?: ArcadeColors
  typography?: keyof typeof typography
  textAlign?: CSSProperties['textAlign']
  // CSSProperties does not yet include textWrap so we have to manually add the type.
  textWrap?:
    | 'wrap'
    | 'nowrap'
    | 'balance'
    | 'pretty'
    | 'stable'
    | 'inherit'
    | 'initial'
    | 'revert'
    | 'revert-layer'
    | 'unset'
  overflowWrap?: CSSProperties['overflowWrap']
}>`
  ${({ themeColor }) => {
    if (!themeColor) return ''
    return `color: ${useGetArcadeColor(themeColor)};`
  }}
  ${({ theme, typography }) => (typography ? theme.typography[typography] : '')}
  ${({ textAlign }) => (textAlign ? `text-align: ${textAlign};` : '')}
  ${({ textWrap }) => (textWrap ? `text-wrap: ${textWrap};` : '')}
  ${({ overflowWrap }) => (overflowWrap ? `overflow-wrap: ${overflowWrap};` : '')}
`

// Wraps the TextBase since if we pass a `color` attribute directly to a styled component
// it will show up as an attribute in the DOM.
const Text = ({
  color,
  ...rest
}: Omit<React.ComponentProps<typeof TextBase>, 'themeColor'> & {
  color?: React.ComponentProps<typeof TextBase>['themeColor']
}) => {
  return <TextBase themeColor={color} {...rest} />
}

export default Text
